export default __webpack_public_path__ + "static/media/menu-toggle.22fa4a85.svg";